"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { signOutAgent } from "@aluume/shared/lib/auth/agent";

// Light top nav for the agent portal (matches Figma 687:2) — distinct from the
// dark staff sidebar. Active link by pathname.
const LINKS = [
  { href: "/agent", label: "Dashboard" },
  { href: "/agent/book", label: "Book" },
  { href: "/agent/bookings", label: "My bookings" },
  { href: "/agent/invoices", label: "Invoices" },
  { href: "/agent/account", label: "Account" },
];

export function AgentNav({ agentName }: { agentName: string }) {
  const pathname = usePathname();

  async function logout() {
    await signOutAgent();
    window.location.assign("/login");
  }

  const isActive = (href: string) =>
    href === "/agent" ? pathname === "/agent" : pathname === href || pathname.startsWith(href + "/");

  return (
    <header className="flex h-[76px] items-center justify-between border-b border-ink/10 bg-cream px-12">
      <Link href="/agent" className="flex items-center gap-2.5">
        <span style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 300 }}>Aluume</span>
        <span className="h-4 w-px bg-ink/25" />
        <span className="eyebrow text-ink/55" style={{ fontSize: 10 }}>Agent Portal</span>
      </Link>

      <nav className="flex items-center gap-8">
        {LINKS.map((l) => (
          <Link
            key={l.href}
            href={l.href}
            className="text-[13.5px] transition-colors"
            style={{
              fontFamily: "var(--font-sans)",
              fontWeight: isActive(l.href) ? 500 : 300,
              color: isActive(l.href) ? "var(--ink)" : "rgba(57,51,49,0.6)",
            }}
          >
            {l.label}
          </Link>
        ))}
      </nav>

      <div className="flex items-center gap-3">
        <span className="text-[13px] text-ink-soft" style={{ fontFamily: "var(--font-sans)" }}>{agentName}</span>
        <button
          onClick={logout}
          aria-label="Sign out"
          title="Sign out"
          className="flex h-[30px] w-[30px] items-center justify-center rounded-full text-ink-soft transition-colors hover:bg-ink/5 hover:text-ink"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </header>
  );
}
